<template>
  <div class="image-wrappers clearfix">
    <!--<p>图片消息(点击预览)</p>-->
    <img v-if="imgUrl==='loading'" class="img-loading" src="@/assets/images/imgLoad.png" alt="加载中..." />
    <div v-else class="img-containers" :class="{ self: isSelf(msg.sendType) }">
      <img v-if="msg.msgTip&&msg.msgTip==='isDelete'" style="width: 16px;height: auto;position: absolute;left:-26px;top: 45%;" src="@/assets/images/field.png" alt="上传失败" />
      <img :src="imgUrl" @click="clickImg" />
    </div>
  </div>
</template>
<script>
/**
   * 图片类型消息显示
   */
export default {
  name: 'ImageMsg',
  props: {
    msg: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      visible: false,
      srcUrl: process.env.VUE_APP_CHAT_SERVER + '/fastDfs/download?recordFile='
    }
  },
  computed: {
    imgUrl() {
      const srcUrl = this.msg && (this.msg.srcUrl || this.msg.content)
      if (srcUrl === 'loading') return 'loading'
      if (srcUrl === 'field') return 'field'
      if (srcUrl.indexOf('blob:') > -1) return this.msg.srcUrl
      return this.srcUrl + srcUrl
    }
  },
  methods: {
    isSelf(sendType) {
      return !(
        sendType &&
            (sendType.toUpperCase() === 'SEND' ||
                sendType.toUpperCase() === 'AUTO_REPLY')
      )
    },
    clickImg() {
      this.visible = true
      const arr = []
      arr.push(this.imgUrl)
      this.$createImagePreview({
        imgs: arr
      }, (h) => {
        return h('div', {
          class: {
            'cube-image-preview-footer': false
          },
          slot: 'footer'
        }, '')
      }).show()
    }
  }
}
</script>
<style lang="stylus">
  @media screen and (min-width: 992px) {
    .cube-popup {
      width 992px
      margin 0 auto
    }
  }
  .image-wrappers
    .img-containers {
      position relative
      &.self {
        max-width 160px
        max-height 300px
        float: right;
      }
      img {
        height auto
        width 160px
        max-height 300px
      }
    }
  .img-loading {
    animation: animate 0.7s infinite;
  }
  @keyframes animate {
    0% {
      transform: rotate(0deg)
    }
    100% {
      transform: rotate(360deg)
    }
  }
  .clearfix:after {
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
</style>
